import React from "react";
import { useSettingModel } from "../settingModel";
import { ISearchValue, SearchTypeEnum } from "../../../../components/YhPageHeader/Types";
import { YhPageHeader } from "../../../../components/YhPageHeader";
import { branchDs } from "../../../../utils/constants";

const searchFields = [
    {
        type: SearchTypeEnum.Select,
        xxl: 4,
        span: 4,
        placeholder: "从属分支",
        fieldName: "branch",
        size: "small",
        disabled: false,
        options: branchDs
    },
    {
        type: SearchTypeEnum.Input,
        xxl: 4,
        span: 4,
        placeholder: "配置编码",
        fieldName: "code",
        size: "small",
        disabled: false
    },
]

export const PageHeader = () => {
    const {
        searchParam,
        loadData,
        updateSearchParam,
        resetSearchParam
    } = useSettingModel();

    return (
        <YhPageHeader
            title="系统配置管理"
            searchValues={searchParam as ISearchValue}
            searchFields={searchFields}
            onChange={updateSearchParam}
            triggerSearch
            handleSearch={(val = {}) => loadData({ ...searchParam, ...val })}
            handleReset={resetSearchParam}
        />
    );
}